import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contents/tms-2/what-is-tms-therapy")({
  beforeLoad: () => {
    throw redirect({
      to: "/contents/tms/what-is-tms-therapy",
      replace: true,
    });
  },
});
